import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import LinkIcon from '@mui/icons-material/Link';
import { Icons } from '@Assets/SvgIcons';
import React from 'react';

export type FileActionMenuItem = {
  action: string;
  icon: JSX.Element;
  text: string;
  hasDivider?: boolean;
  hideOn?: string[]
};

export const FileActionMenuItems: FileActionMenuItem[] = [
  { 
    action: 'new_tab',
    icon: <ArrowOutwardIcon fontSize="small" />,
    text: 'Open in new tab',
    hideOn: ['file'],
  },
  { 
    action: 'copy',
    icon: <LinkIcon fontSize="small" />,
    text: 'Copy Link',
    hideOn: ['file'],
  },
  { 
    action: 'move',
    icon: <Icons.Move />,
    text: 'Move',
  },
  { 
    action: 'rename',
    icon: <Icons.Rename  />,
    text: 'Rename',
  },
  { 
    action: 'edit',
    icon: <Icons.Description2 />,
    text: 'Edit Description',
  },
  { 
    action: 'delete',
    icon: <Icons.DeleteFilled  />,
    text: 'Delete',
  },
];
